import React, { useState, useEffect } from 'react';
import { ListGroupItem, ListGroup, Button, Badge } from 'reactstrap';
import { FaCloudUploadAlt, FaCheck } from 'react-icons/fa';

// Redux
import { connect } from 'react-redux';

const mapStateToProps = state => ({
    usuarioActivo: state
})

const FileUploader = (props) => {
    return (
        <div className='retiro-modal-button-area-firma'>
            <input type="file" id='uploadAssetsInput' onChange={(e) => { props.addFile({ file: e.target.files[0], id:props.id}) }} style={{ display: 'none' }} />
            <Button
                disabled={!props.estado}
                onClick={() => { document.getElementById('uploadAssetsInput').click() }}
                style={{ outline: 'none', verticalAlign:'center', justifyContent:'center' }}
                color="link"
                outline>
                {`${props.name} `}
                <FaCloudUploadAlt size={20} />
            </Button>
        </div>
    )
}

const CardAdjunto = (props) => {
    return (
        <React.Fragment>
            <ListGroup>
                {props.list.map((item, index) => {
                    return <ListGroupItem key={`area_list_item_${index}`} color="info">
                        <div className='retiro-adjuntos-area'>
                            <div className='retiro-adjuntos-area-name'>
                                {item.name}
                            </div>
                            <div className='retiro-adjuntos-area-attachments'>
                                {item.adjuntos.map((adjunto, index) => {
                                    let pos = props.attachmentsList.findIndex(i => i.fileName.split('.')[0] === `${adjunto.key}`)
                                    if (pos< 0) {
                                        return <FileUploader
                                            estado={props.estado === item.estado_editable}
                                            key={adjunto.key}
                                            id={adjunto.key}
                                            name={adjunto.name}
                                            addFile={(e) => props.addFile(e)} />
                                    }
                                    else {
                                        return (<Button
                                            disabled
                                            style={{ outline: 'none', verticalAlign: 'center', justifyContent: 'center' }}
                                            color="link"
                                            outline>
                                            {`${adjunto.name} `}
                                            <FaCheck size={20} />
                                        </Button>);
                                    }
                                })}
                            </div>

                        </div>
                    </ListGroupItem>
                })}

            </ListGroup>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(CardAdjunto);